<template>
  <div class="card" id="characterModel">
    <nav class="fixed-bar navbar navbar-expand-lg navbar-light" color="white">
      <h3 class="navbar-brand">Character Model</h3>
      <add-character-model
        @save="saveSetDesign"
        @open="openDialog"
        @close="closeDialog"
        v-bind:dialog="dialog"
        v-bind:info="editedItem"
        v-bind:edited-i-d="editedID"
        v-bind:showSaveButton="showSaveButton">
      </add-character-model>
    </nav>
    <hr/>
    <div class="container fluid grid-list-lg">
      <asset-table
        v-bind:updated="updated"
        v-bind:asset_type="asset_type"
        @edit="editItem"
        v-bind:headers="headers">
      </asset-table>
    </div>
  </div>
</template>

<script>
import AddCharacterModel from './add-new/addCharacterModel'
import { db, assetMediaStorageRef, assetModelStorageRef } from '../../firebaseDB'
import AssetTable from './assetTable'
import _ from 'lodash'

export default {
  name: 'character-model',
  components: { AssetTable, AddCharacterModel },
  data: () => ({
    asset_type: 'character_model',
    fileType: {
      image: 'image',
      fbx: 'fbx',
      asset_bundle: 'asset_bundle'
    },
    headers: [
      {th: 'Name', name: 'name'},
      {th: 'Date Uploaded', name: 'date_uploaded'},
      // {th: 'Date Modified', name: 'date_modified'},
      {th: 'Uploaded By', name: 'creator'},
      // {th: 'Description', name: 'description'},
      // {th: 'Service', name: 'service'},
      {th: 'Media',
        name: 'media',
        render (row, cell, index) {
          if (row.hasOwnProperty('image')) {
            return `<a href="${row.image.imageURL}" target="_blank">
                  <img src="${row.image.imageURL}" style="width: 50px; height: 50px">
                </a>`
          } else {
            return ''
          }
        }
      },
      // {th: 'Rig', name: 'rig'},
      {th: 'Scale', name: 'scale'},
      {th: 'Polygon Count', name: 'polygon_count'},
      // {th: 'Asset Dimensions (meters x,y,z)', name: 'dimension_revised'}
    ],
    osType: {
      iOS: 'iOS',
      Android: 'Android',
      WebGL: 'WebGL'
    },
    dialog: '',
    updated: false,
    showSaveButton: true,
    editedItem: {
      id: null,
      name: '',
      service: '',
      image: null,
      description: '',
      rig: 'Humanoid',
      polygon_count: 1,
      dimension: {
        X: 0,
        Y: 0,
        Z: 0
      },
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        WebGL: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      scale: 0,
    },
    defaultItem: {
      id: null,
      name: '',
      service: '',
      image: null,
      description: '',
      rig: 'Humanoid',
      polygon_count: 1,
      dimension: {
        X: 0,
        Y: 0,
        Z: 0
      },
      fbx: {
        fileName: '',
        file: '',
        fileURL: ''
      },
      asset_bundle: {
        iOS: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        Android: {
          fileName: '',
          file: '',
          fileURL: ''
        },
        WebGL: {
          fileName: '',
          file: '',
          fileURL: ''
        }
      },
      scale: 0,
    },
    editedID: -1,
    editedIndex: -1
  }),
  methods: {
    saveSetDesign (updatedData) {
      setTimeout(() => {
        let updates = {}
        let requireDefaultUpdate = true

        this.updateMetaData(updatedData, updates)

        updates[`asset_data/${this.asset_type}/${updatedData.id}/name`] = updatedData.name || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/service`] = updatedData.service || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/description`] = updatedData.description || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/rig`] = updatedData.rig || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/scale`] = updatedData.scale || 1
        updates[`asset_data/${this.asset_type}/${updatedData.id}/polygon_count`] = updatedData.polygon_count || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/material`] = updatedData.material || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/interactive_surface`] = updatedData.interactive_surface || ''
        updates[`asset_data/${this.asset_type}/${updatedData.id}/dimension`] = {
          X: updatedData.dimension.X || '',
          Y: updatedData.dimension.Y || '',
          Z: updatedData.dimension.Z || ''
        }

        if (this.shouldUpload(this.fileType.image, updatedData)) {
          this.uploadImage(updatedData, updates)
          requireDefaultUpdate = false
        }
        if (this.shouldUpload(this.fileType.fbx, updatedData)) {
          this.uploadFBX(updatedData, updates)
          requireDefaultUpdate = false
        }
        if (this.shouldUpload(this.fileType.asset_bundle, updatedData)) {
          this.uploadAssetBundle(updatedData, updates, this.osType.iOS)
          this.uploadAssetBundle(updatedData, updates, this.osType.Android)
          this.uploadAssetBundle(updatedData, updates, this.osType.WebGL)
          requireDefaultUpdate = false
        }
        if (requireDefaultUpdate) {
          db.ref('assets').update(updates).then(snapshot => {
            this.closeDialog()
            this.updated = true
          })
        }
      }, 2000)
      this.updated = false
    },
    getDatetime () {
      const currentdate = new Date()
      return currentdate.getDate() + '/' +
        (currentdate.getMonth() + 1) + '/' +
        currentdate.getFullYear() + ' - ' +
        currentdate.getHours() + ':' +
        currentdate.getMinutes() + ':' +
        currentdate.getSeconds()
    },
    updateMetaData (updatedData, updates) {
      const datetime = this.getDatetime()
      if (!updatedData.id) {
        updatedData.id = db.ref(`asset_data/${this.asset_type}/`).push().key
        updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/creator`] = this.$store.state.user.email
        updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_uploaded`] = datetime
      }
      updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_modified`] = datetime
    },
    shouldUpload (fileType, updatedData) {
      if (fileType === this.fileType.image) {
        return updatedData.image && updatedData.image.imageFile
      } else if (fileType === this.fileType.fbx) {
        return updatedData.fbx && updatedData.fbx.file
      } else if (fileType === this.fileType.asset_bundle) {
        return (updatedData.asset_bundle.iOS && updatedData.asset_bundle.iOS.file) ||
          (updatedData.asset_bundle.Android && updatedData.asset_bundle.Android.file) ||
          (updatedData.asset_bundle.WebGL && updatedData.asset_bundle.WebGL.file)
      } else {
        return false
      }
    },
    uploadImage (updatedData, updates) {
      assetMediaStorageRef.child(`${updatedData.id}.jpg`)
        .put(updatedData.image.imageFile)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .catch(function (error) {
          console.log(`Error - ${error.message}`)
        })
        .then((url) => {
          updatedData.image.imageURL = url
        })
        .catch(function (error) {
          console.log(`Error - ${error.message}`)
        })
        .then(snapshot => {
          updates[`asset_data/${this.asset_type}/${updatedData.id}/image`] = updatedData.image || {imageURL: '', imageFile: ''}
          console.log('Your image file is saved in storage')
          db.ref('assets').update(updates)
            .then(snapshot => {
              this.closeDialog()
              this.updated = true
              console.log('Your image fileURL is saved in assets')
            })
        })
        .catch(function (error) {
          console.log('Error - ' + error.message)
        })
    },
    uploadFBX (updatedData, updates) {
      assetModelStorageRef.child(`${updatedData.id}/original.fbx`)
        .put(updatedData.fbx.file)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .catch(function (error) {
          console.log(`Error - ${error.message}`)
        })
        .then((url) => {
          updatedData.fbx.fileURL = url
          console.log('Transferring file url')
        })
        .then(snapshot => {
          updates[`asset_data/${this.asset_type}/${updatedData.id}/fbx`] = updatedData.fbx || {
            fileURL: '',
            file: ''
          }
          console.log('Your fbx file is saved in storage')
          db.ref('assets').update(updates)
            .then(snapshot => {
              this.closeDialog()
              this.updated = true
              console.log('Your fbx fileURL is saved in assets')
            })
        })
    },
    uploadAssetBundle (updatedData, updates, osType) {
      if (updatedData.asset_bundle[osType] && updatedData.asset_bundle[osType].file) {
        assetModelStorageRef.child(`${updatedData.id}/${osType}`)
          .put(updatedData.asset_bundle[osType].file)
          .then(snapshot => snapshot.ref.getDownloadURL())
          .catch(function (error) {
            console.log(`Error - ${error.message}`)
          })
          .then((url) => {
            updatedData.asset_bundle[osType].fileURL = url
            console.log('Transferring asset bundle url')
          })
          .then(snapshot => {
            let key = `asset_data/${this.asset_type}/${updatedData.id}/asset_bundle/${osType}`
            updates[key] = updatedData.asset_bundle[osType] || {
              fileURL: '',
              file: ''
            }
            console.log(`Your ${osType} asset bundle is saved in storage`)
            db.ref('assets').update(updates)
              .then(snapshot => {
                this.closeDialog()
                this.updated = true
                console.log(`Your ${osType} asset bundle fileURL is saved in assets`)
              })
          })
      }
    },
    openDialog () {
      this.dialog = true
    },
    closeDialog () {
      this.editedID = -1
      this.editedIndex = -1
      this.editedItem = _.cloneDeep(this.defaultItem)
      this.dialog = false
    },
    editItem (item) {
      this.editedIndex = item.index
      this.editedID = item.id
      this.editedItem = item.item
      this.showSaveButton = item.showSaveButton
      this.dialog = true
    }
  }
}
</script>

<style scoped>
#characterModel {
  scroll-margin: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/assets/characterModel.vue